import { storeLang } from '../utils/translations'
import { syncI18nLanguage } from '../localize/i18n'
export const UPDATE_SETTINGS = "UPDATE_SETTINGS"
export const UPDATE_DELIVERY_SCHEDULE = "UPDATE_DELIVERY_SCHEDULE"
export const UPDATE_ORDER_SCHEDULE = "UPDATE_ORDER_SCHEDULE"
export const UPDATE_DELIVERY_SETTINGS = "UPDATE_DELIVERY_SETTINGS"
export const UPDATE_TAKEAWAY_SETTINGS = "UPDATE_TAKEAWAY_SETTINGS"

export function updateRestoSettings(id, color, autoAcceptOrder, delivery, takeaway, table, stripe, orderTypePopup, sharedCart, currencySymbol, showCurrency = true) {
  return {
    type: UPDATE_SETTINGS,
    payload: {
      id,
      color,
      autoAcceptOrder,
      delivery,
      takeaway,
      table,
      stripe,
      orderTypePopup,
      sharedCart,
      currencySymbol,
      showCurrency
    }
  }
}

export function updateDeliverySchedule(deliverySchedule) {
  return {
    type: UPDATE_DELIVERY_SCHEDULE,
    payload: {
      deliverySchedule
    }
  }
}

export function updateOrderSchedule(orderSchedule) {
  return {
    type: UPDATE_ORDER_SCHEDULE,
    payload: {
      orderSchedule
    }
  }
}

export function updateDeliverySettings(deliverySettings) {
  return {
    type: UPDATE_DELIVERY_SETTINGS,
    payload: {
      deliverySettings
    }
  }
}

export function updateTakeawaySettings(takeawaySettings) {
  return {
    type: UPDATE_TAKEAWAY_SETTINGS,
    payload: {
      takeawaySettings
    }
  }
}

export const UPDATE_MENU_SETTINGS = "UPDATE_MENU_SETTINGS"
export const SET_LANGUAGE = "SET_LANGUAGE"

// Réglages menu pilotés par le backoffice : commentaires produit + langues activées
export function updateMenuSettings({ productComments, languages }) {
  return {
    type: UPDATE_MENU_SETTINGS,
    payload: {
      productComments: productComments === true,
      languages: languages && typeof languages === 'object' ? languages : null
    }
  }
}

// Une seule source de vérité : le sélecteur pilote les données ET l'interface (i18next)
export function setLanguage(lang) {
  storeLang(lang)
  syncI18nLanguage(lang)
  return {
    type: SET_LANGUAGE,
    payload: {
      lang
    }
  }
}
